export default __webpack_public_path__ + "static/passface-3b9b90f4807b49cf2e03da76b03fa1fb.gif";